import { State } from 'src/types'
import { higashiUrawaBackStyleDrawerLeftThrow } from './higashiUrawaBackStyleDrawer'
import { beltBackStyleDrawerLeftThrow } from './beltBackstyle'

export const backStyleOfGloveBackDrawerLeftThrow = (ctx: CanvasRenderingContext2D, state: State, canvasWidth: number): void => {
  const needCatchFaceWrap = !state.baseModel?.isUBack || false

  switch (state?.baseModel?.productNumber) {
    case 'BKN-20':
      higashiUrawaBackStyleDrawerLeftThrow(ctx, state, needCatchFaceWrap, canvasWidth)
      break
    default:
      beltBackStyleDrawerLeftThrow(ctx, state, needCatchFaceWrap, canvasWidth)
      break
  }
}
